import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchBroadcastReach, sendMeetupBroadcast} from '../endpoints/api';

export const enum BROADCAST_AUDIENCE {
  ANYONE = 'anyone',
  LOCAL_INSIDERS_CLUB = 'local_insiders_club',
}

export const useMeetupBroadcast = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: sendMeetupBroadcast,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['infinite_meetups']);
      queryClient.invalidateQueries(['meetup', variables.eventId]);
    },
  });
};

export const useBroadcastReach = ({
  audienceRuleset,
  placeId,
}: {
  audienceRuleset: string;
  placeId?: string;
}) => {
  return useQuery({
    queryKey: ['broadcastReach', {audienceRuleset, placeId}],
    queryFn: () => fetchBroadcastReach({audienceRuleset, placeId}),
    enabled: Boolean(placeId),
  });
};
